import { render, staticRenderFns } from "./BusinessBasicData.vue?vue&type=template&id=777bf914&"
import script from "./BusinessBasicData.vue?vue&type=script&lang=ts&"
export * from "./BusinessBasicData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports